import { render, staticRenderFns } from "./packplan.vue?vue&type=template&id=1540a26c&scoped=true&"
import script from "./packplan.vue?vue&type=script&lang=js&"
export * from "./packplan.vue?vue&type=script&lang=js&"
import style0 from "./packplan.vue?vue&type=style&index=0&id=1540a26c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1540a26c",
  null
  
)

export default component.exports